import React from 'react';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  return (
    <footer id="footer">
      <NavLink to="/mentions_legales">
        Mentions légales
      </NavLink>
      <p>© Delphia Paul 2026</p>
    </footer>
  );
};

export default Footer;